var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { ApiClient } from ".";
import ErrorBoundaryView from "../components/error-boundary-view";
var widgetLoader = function (getComponent, errBoundaryProps, healthCheckUrl, onFinish) {
    var AsyncComponent = /** @class */ (function (_super) {
        __extends(AsyncComponent, _super);
        function AsyncComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                healthCheckfailed: false
            };
            return _this;
        }
        AsyncComponent.prototype.componentDidMount = function () {
            var _this = this;
            if (healthCheckUrl) {
                ApiClient.get(healthCheckUrl, undefined, true)
                    .then(function () {
                    getComponent()
                        .then(function (cmp) {
                        _this.setState({ Component: cmp.default });
                        if (onFinish)
                            onFinish(true);
                    }).catch(function () {
                        if (onFinish)
                            onFinish(false);
                    });
                }).catch(function () {
                    _this.setState({ healthCheckfailed: true });
                    if (onFinish)
                        onFinish(false);
                });
            }
            else {
                getComponent()
                    .then(function (cmp) {
                    _this.setState({ Component: cmp.default });
                    if (onFinish)
                        onFinish(true);
                }).catch(function () {
                    if (onFinish)
                        onFinish(false);
                });
            }
        };
        AsyncComponent.prototype.render = function () {
            var _a = this.state, Component = _a.Component, healthCheckfailed = _a.healthCheckfailed;
            return Component || healthCheckfailed ?
                React.createElement(ErrorBoundaryView, __assign({}, errBoundaryProps, { forceError: (errBoundaryProps === null || errBoundaryProps === void 0 ? void 0 : errBoundaryProps.forceError) || healthCheckfailed }), Component && React.createElement(Component, __assign({}, this.props)))
                :
                    React.createElement(React.Fragment, null);
        };
        return AsyncComponent;
    }(React.Component));
    return AsyncComponent;
};
export default widgetLoader;
//# sourceMappingURL=widget-loader.js.map